import { Loader2 } from 'lucide-react';

/** The whole-viewport wait, used while the session or profile resolves. */
export function FullPageLoader({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="grid min-h-full place-items-center text-muted" aria-busy="true" aria-live="polite">
      <span className="flex items-center gap-2 text-sm">
        <Loader2 className="size-4 animate-spin motion-reduce:animate-none" aria-hidden="true" />
        {label}
      </span>
    </div>
  );
}
